import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, time, msg } from './hubApi';
import { useApp } from './HubContext';
import { GoLive } from './Account';

function Stream() {
  const { user, setUser } = useApp();
  const [err, setErr] = useState('');
  if (!user) return <section className="card"><h2>Stream your race day</h2><p className="fine"><Link to="/">Log in</Link> to go live and chat.</p></section>;
  if (!user.leaderboard?.optIn) {
    const join = async () => { try { setUser(await api('/me/leaderboard', { method: 'POST', body: { optIn: true, declaredBank: user.bank || 1000 } })); } catch (e) { setErr(msg(e)); } };
    return (
      <section className="card">
        <h2>Stream your race day</h2>
        <p className="fine">To go live you need a public tipping record. Joining the leaderboard publishes the results of your own picks, in units. Your balance and dollar stakes stay private.</p>
        <div className="row"><button className="sm" onClick={join}>Join the leaderboard</button>{err && <span className="note">{err}</span>}</div>
      </section>
    );
  }
  return <GoLive user={user} setUser={setUser} />;
}

export default function Live() {
  const [rows, setRows] = useState(null);
  useEffect(() => { const load = () => api('/live').then(setRows); load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, []);
  return (
    <>
    <section className="card">
      <h2>Live now</h2>
      <p className="fine">Leaders streaming their own race-day commentary. Picks they publish appear in the chat as they make them.</p>
      {!rows ? <p>Loading…</p> : !rows.length ? <p className="fine">No one is live right now.</p> :
        <div className="livegrid">{rows.map(r => (
          <Link key={r.handle} to={'/hub/watch/' + r.handle} className="livecard">
            <span className="pill live">LIVE</span>
            <b>{r.title || r.displayName}</b>
            <span className="fine">{r.displayName} · since {time(r.startedAt)} · {r.viewers} watching · {{ youtube: 'YouTube', twitch: 'Twitch', kick: 'Kick' }[r.provider] || r.provider}</span>
          </Link>))}
        </div>}
    </section>
    <Stream />
    </>
  );
}
